// Image sources require four WGS84 corners, not a flat [west, south, east, north] bbox.
export const isValidImageCoordinates = (coordinates) => {
  if (!Array.isArray(coordinates) || coordinates.length !== 4 || !coordinates.every(
    (pair) => Array.isArray(pair) && pair.length === 2 && pair.every(Number.isFinite) &&
      Math.abs(pair[0]) <= 180 && Math.abs(pair[1]) <= 90
  )) {
    return false
  }

  const [originLng, originLat] = coordinates[0]
  const area = coordinates.reduce((total, [lng, lat], index) => {
    const [nextLng, nextLat] = coordinates[(index + 1) % 4]
    return total + (lng - originLng) * (nextLat - originLat) -
      (nextLng - originLng) * (lat - originLat)
  }, 0)
  return Number.isFinite(area) && area !== 0 &&
    new Set(coordinates.map((pair) => pair.join(','))).size === 4
}
